<!-- Start Footer -->
<footer class="footer theme-bg overflow-hidden">
  <!-- Circle Animations Effect
  <ul class="circles">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
-->
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="footer-top">
          <div
            class="foot_logo d-flex align-items-center justify-content-center"
          >
            <img
              src="assets/images/logo.png"
              class="img-fluid d-block"
              alt=""
            />
          </div>
          <p
            class="ftr-about"
            i18n
            [innerHTML]="'enliiigne.TakeTheGuessingOut' | translate"
          ></p>
        </div>
      </div>
      <div class="col-lg-12 justify-content-center">
        <div class="row d-flex align-items-center justify-content-center">
          <a href="https://apps.apple.com/app/id1519528422" target="_blank"
            ><img
              src="assets/images/downloadapple_en.png"
              class="img-fluid d-block"
              alt=""
          /></a>
          <a
            href="https://play.google.com/store/apps/details?id=com.nofriction.en_ligne"
            target="_blank"
            ><img
              src="assets/images/downloadplay_en.png"
              class="img-fluid d-block"
              alt=""
          /></a>
        </div>
      </div>

      <div class="col-lg-12">
        <ul class="footer_menu_list list-unstyled mb-2">
          <li>
            <a
              routerLink="/"
              i18n
              [innerHTML]="'enliiigne.Home' | translate"
            ></a>
          </li>
          <li>
            <a
              routerLink="/contact"
              i18n
              [innerHTML]="'enliiigne.ContactUs' | translate"
            ></a>
          </li>
          <li>
            <a
              routerLink="/eula"
              i18n
              [innerHTML]="'enliiigne.EULA' | translate"
            ></a>
          </li>
          <li>
            <a
              routerLink="/privacy"
              i18n
              [innerHTML]="'enliiigne.Privacy' | translate"
            ></a>
          </li>
        </ul>
      </div>
      <div class="col-lg-12">
        <div class="copyrights">
          <p class="mb-0 text-center" i18n>
            2020 &copy;
            <span class="text-white font-weight-bold"
              >EnL<span class="red-font">iii</span>gne</span
            >
          </p>
        </div>
      </div>
      <div class="col-12">
        <!-- <div class="d-flex align-items-center justify-content-center">
          <a
            class="social-icons"
            href="https://www.facebook.com/EnLiiigne-102960964807374"
            ><i class="mdi mdi-facebook-box"></i
          ></a>
          <a class="social-icons" href="#"><i class="mdi mdi-twitter"></i></a> -->
        <!--  <a class="social-icons" href="#"><i class="mdi mdi-dribbble"></i></a> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</footer>
<!-- End Footer -->
<!-- Back To Top -->
<a href="#" class="back_top"> <i class="mdi mdi-chevron-up"></i></a>
